import React from "react";
import "./styles.css";

export default function AboutUs() {
  return (
    <div style={{ padding: "20px" }}>
      <h1>关于我们</h1>
      <p>欢迎使用我们的应用程序！我们致力于为用户提供最佳的体验和服务。</p>
      <p>如果您有任何问题或建议，请随时联系我们的客服团队。</p>
      <p>感谢您的支持！</p>
    </div>
  );
}
